import { render, staticRenderFns } from "./CustomAudioPlayer.vue?vue&type=template&id=5518640d&scoped=true&"
import script from "./CustomAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./CustomAudioPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5518640d",
  null
  
)

export default component.exports